import React, { useState,useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Container,Row,Col,Card,Placeholder } from 'react-bootstrap';
const Examinations = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const[isLoading, setLoading] = useState(true);
    const[Pages,setPages]=useState([]);
    useEffect(()=>
    {
        const researchPages = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"menu/subMenu/8");
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sp_id + "/spImage")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sp_id + "/spImageHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].spImage = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].spImageHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                        });
                        setPages(result);
                        setLoading(false);
                    }).catch(error => {
                        console.error('Examinations File :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setPages([]);
                    setLoading(false);            
                }
                if( global.config.IsPrint === true ) { console.info('Examinations Pages : Result',result); }
            } catch (error) 
            {
                console.error('Examinations Pages : Error', error.message);
                setLoading(false);
            }
        };
        researchPages();    
    },[])
    return (
        <Container className="py-5">
            <Card className='bg-info-subtle'>
                <Card.Header className='fs-4 text-center text-uppercase'>
                    {appLanguage === 'hi' ? "परीक्षाएँ" : "Examinations"}
                </Card.Header>
                <Card.Body className='p-5'>
                {isLoading ? (
                    <Row className="g-5">
                    {[...Array(10)].map((_,index)=>(
                        <Col md={4} key={index}>
                            <Card className='card-modal-one' data-aos="flip-up" data-aos-duration="1500">
                                <Placeholder xs={12} className="card-img-top" style={{minHeight:"180px"}} />
                                <Card.Body>
                                    <div className="card-action active">
                                        <div className="fw-bold"><Placeholder xs={10} /></div>
                                        <a className="link-dark" href="/"><Placeholder xs={12} /></a>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                    </Row>
                ) : (
                    <Row className="g-5">
                    {Pages.map((sp, index)=>(
                        <Col md={4} key={index}>
                            <Card className='card-modal-one' data-aos="flip-up" data-aos-duration="1500">
                                {appLanguage === 'hi' ? (
                                    sp.spImageHi ? (
                                        <Card.Img src={sp.spImageHi} className='rounded-0' />
                                    ) : sp.spImage ? (
                                        <Card.Img src={sp.spImage} className='rounded-0' />
                                    ) : (
                                        <Placeholder xs={12} className="card-img-top" style={{ minHeight: "180px" }} />
                                    )
                                ) : sp.spImage ? (
                                    <Card.Img src={sp.spImage} className='rounded-0' />
                                ) : (
                                    <Placeholder xs={12} className="card-img-top" style={{ minHeight: "180px" }} />
                                )}
                                <Card.Body>
                                    <div className="card-action fw-bold active">
                                        <div>{appLanguage === 'hi' ? sp.sp_name_hi || sp.sp_name : sp.sp_name}</div>
                                        <NavLink className="link-dark" to={`${sp.parentMenu.sp_htaccess}/${sp.sp_htaccess}`}>
                                            {t('ReadMore')} <i className="bi bi-arrow-right-short"></i>
                                        </NavLink>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                    </Row>
                )}
                </Card.Body>
            </Card>
        </Container>
    );    
}
export default Examinations;